import { render, staticRenderFns } from "@/modules/Case/templates/case-dashboard.html?vue&type=template&id=83d88106&scoped=true&"
import script from "@/modules/Case/scripts/case-dashboard.ts?vue&type=script&lang=js&"
export * from "@/modules/Case/scripts/case-dashboard.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Case/styles/case-dashboard.scss?vue&type=style&index=0&id=83d88106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d88106",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
